import { render, staticRenderFns } from "./ClassificationsList.vue?vue&type=template&id=5a22dfa8&"
import script from "./ClassificationsList.vue?vue&type=script&lang=js&"
export * from "./ClassificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports